export const selectActiveEnrichment = state => state.enrichment.activeEnrichment

export const selectNextEnrichment = state => state.enrichment.nextEnrichment

export const selectOpenOnLoad = state => state.enrichment.openOnLoad
